import {
  Component,
  EventEmitter,
  Input,
  Output,
  AfterViewInit,
  Renderer2,
  ViewChild,
  ElementRef,
  SimpleChanges,
  OnInit,
  OnChanges,
} from "@angular/core";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";
import { ServiceService } from "../chargesbyservice/chargeser.service";
declare var bootstrap: any;
declare var $: any;

@Component({
  selector: "app-filter-by-tags",
  templateUrl: "./filterbytags.component.html",
})
export class FilterByTagsComponent implements OnInit, OnChanges {
  @ViewChild("dropdownToggle", { static: false }) dropdownToggle!: ElementRef;
  @Input() showModal:any;
  @Output() close = new EventEmitter<void>();
  @Output() tagsFiltered = new EventEmitter<any>();
  @Input() monthYear: any;
  @Input() accountId: any;

  selectedAccountId = "";
  selectedTagKey = "";
  selectedTagValue = "";

  accountData: any[] = [];
  accountOptions: { id: number; name: string }[] = [];

  tagKeys: any;
  tagValues: any;
  constructor(
    private apiServer: APIService,
    public notifier: NotifierService,
    private service: ServiceService
  ) {}

  ngOnInit() {
    if (this.accountId) {
      this.onAccountIdChange();
    } else {
      const stored = localStorage.getItem("accountIdData");
      if (stored) {
        const parsed = JSON.parse(stored);
        const list = parsed.list || [];

        this.accountOptions = list.map((item: any) => ({
          id: item.accountId,
          name: `${item.accountName} (${item.accountId})`,
        }));
      }
    }
    if(this.showModal){
      this.selectedTagKey = this.showModal.tagKey;
      this.selectedTagValue = this.showModal.tagValue;

    }
  }

  async tagsKey() {
    this.notifier.loading(true);
    const [month, year] = this.monthYear.split("-");
    const params: any = {
      account_id: this.selectedAccountId ?? this.accountId,
      year: year,
      month: month,
    };

    try {
      const { result } = await this.service.loadData(params, "/tags");
      this.tagKeys = result.response?.tag_keys || [];

      setTimeout(() => {
        $(".selectpicker").selectpicker("refresh");
      }, 0);
    } catch (error) {
      console.error("Error fetching tag keys:", error);
      this.tagKeys = [];
    }

    this.notifier.loading(false);
  }

  onAccountIdChange(acctId?: string) {
    this.selectedAccountId = acctId ?? this.accountId;
    this.selectedTagKey = '';
    this.selectedTagValue ='';
    this.tagsKey();
  }

  onTagKeyChange(tagKey: string) {
    this.selectedTagKey = tagKey;
    this.fetchTagValues();
  }

  async fetchTagValues() {
    this.notifier.loading(true);
    const [month, year] = this.monthYear.split("-");

    const params: any = {
      account_id: this.selectedAccountId ?? this.accountId,
      year: year,
      month: month,
      tag_key: this.selectedTagKey,
    };

    try {
      const { result } = await this.service.loadData(params, "/tags");
      this.tagValues = result.response?.tag_values || [];

      setTimeout(() => {
        $(".selectpicker").selectpicker("refresh");
      }, 0);
    } catch (error) {
      console.error("Error fetching tag values:", error);
      this.tagValues = [];
    }

    this.notifier.loading(false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => this.refreshPicker(), 0);

    if (this.accountId) {
      this.onAccountIdChange(this.accountId);
    }

    const changedLater = (key: "monthYear" | "accountId"): boolean =>
      !!changes[key] && !changes[key].isFirstChange();
    if(this.showModal == null){
      this.selectedTagKey = '';
      this.selectedTagValue ='';
    }
    else{
      this.selectedTagKey = this.showModal.tagKey;
      this.selectedTagValue = this.showModal.tagValue;
    }
  }

  refreshPicker() {
    setTimeout(() => {
      $(".selectpicker").selectpicker("refresh");
    }, 0);
  }

  applyFilter() {
    this.tagsFiltered.emit({
      accountId: this.selectedAccountId ?? this.accountId,
      tagKey: this.selectedTagKey,
      tagValue: this.selectedTagValue,
    });
    this.closeDropdown(); // will now actually close
  }

  closeDropdown() {
    if (this.dropdownToggle?.nativeElement) {
      const bsDropdown =
        bootstrap.Dropdown.getInstance(this.dropdownToggle.nativeElement) ||
        new bootstrap.Dropdown(this.dropdownToggle.nativeElement);
      bsDropdown.hide();
    }
  }
}
